let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j8IQM")).then(() => parcelRequire('iNEPM'));